export default {
  FACET_TOGGLE_LABEL: 'Filter by vehicle',
};
